import { Table } from "../../../../../../components/Functional";
import { FETCH_CRM_REGISTRARS as fetchCRMRegistrars } from "../../../../../../graphql/query/CRMRegistrar";
import SectionHeader from "../../components/SectionHeader";

const Handover = (props = {}) => {
  const { contactId } = props;
  const tableProps = {
    variant: "dynamicHeight",
    dataKey: "crmRegistrars",
    headers: [
      { label: "Date", name: "date", sortKey: "date", type: "date" },
      { label: "From", name: "salesUser.name", type: "label" },
      { label: "To", name: "user.name", type: "label" },
      { label: "Input By", name: "entity.name", type: "label" },
      { label: "Notes", name: "description", type: "label" },
      { label: "Status", name: "status.description", type: "label" },
    ],
    FETCH_QUERY: fetchCRMRegistrars({
      entity: {},
      salesUser: {},
      status: {},
      user: {},
    }),
    variables: {
      contactId,
      typeId: 25, // Handover type
    },
    isSubTable: true,
  };

  return (
    <div className="w-full">
      <SectionHeader title="Handover" />
      <div className="mb-6 w-full">
        <Table {...tableProps} />
      </div>
    </div>
  );
};

export default Handover;
